module.exports = __webpack_public_path__ + "img/003陈利军.bcd71b8e.png";